import { render, staticRenderFns } from "./LetsGo.vue?vue&type=template&id=7062f0e7&scoped=true&"
import script from "./LetsGo.vue?vue&type=script&lang=js&"
export * from "./LetsGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7062f0e7",
  null
  
)

export default component.exports